var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgListIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(0.001)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Area",
    width: 29,
    height: 29,
    transform: "translate(-0.001)",
    fill: "#fcfcfc",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-2",
    "data-name": "Icon",
    transform: "translate(3.625 7.25)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line",
    x2: 15.708,
    transform: "translate(6.041)",
    fill: "none",
    stroke: "#5a6168",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line-2",
    "data-name": "Line",
    x2: 15.708,
    transform: "translate(6.041 7.25)",
    fill: "none",
    stroke: "#5a6168",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line-3",
    "data-name": "Line",
    x2: 15.708,
    transform: "translate(6.041 14.5)",
    fill: "none",
    stroke: "#5a6168",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line-4",
    "data-name": "Line",
    x2: 0.012,
    fill: "none",
    stroke: "#5a6168",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line-5",
    "data-name": "Line",
    x2: 0.012,
    transform: "translate(0 7.25)",
    fill: "none",
    stroke: "#5a6168",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line-6",
    "data-name": "Line",
    x2: 0.012,
    transform: "translate(0 14.5)",
    fill: "none",
    stroke: "#5a6168",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.667
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIcon);
export default __webpack_public_path__ + "static/media/list_icon.ad205e9e49226e02b8219b06a1ffbde4.svg";
export { ForwardRef as ReactComponent };